import edApi from "@/public/utils/edApi";
const $edApi = edApi();

export const state = () => ({
    viewerID: 0,
    workFilter: {
        order: "PV",
        price: 1, //根据价格筛选  1：全部 2：免费 3：付费 4：会员免费
        classId: 0,
        page: 1,
        offset: 0,
        tag: "",
        keyword: "",
        sort: "DESC", // DESC ASC
        rank_tag: "",
        album: null,
        suggest: false,
        follow: false,
    },
    pageCount: 50, // 每一页作品数量

    worksTotal: 0, // 作品总数，用于分页
    worksCurrent: 0, // 当前的页码
    collectTotal: 0,
    collectCurrent: 0,
    menuIndex: 0,

    // 被访问者
    intervieweeUserInfo: {
        // 被访问者用户信息
        user_id: 0,
        avatar: "",
        nick_name: "",
        profile: "",
    },
    followData: [], // 被访问者关注及粉丝数据
    storeWorks: [],
    collectWorks: [], // 被访问者收藏作品
    likeWorks: [],
    hotData: [], // 被访问者热度

    // 访客
    userInfo: {
        user_id: 0,
        token: "",
        lang: "zh",
        nick_name: "",
        max_storage: 0,
        used_storage: 0,
        avatar: "",
        email: "",
        mobile: "",
        islogin: null,
        isVip: 0,
        updateDone: 0,
    },
    getDataDone: false, // 访客数据加载完成
    likeIds: [], // 访客点赞id
    clickUserWordIds: [], // 用户点击记录
    collectIds: [], // 访客收藏id
    followIds: [], // 访客关注id
    isFollowing: -1, // 访客是否关注被访问者

    // edit modal
    iShowEdit: false,
    isPicture: false, //截图背景图片与头像的弹出框
    iShareBox: false, //分享框的显示
    picturefile: null, //图片数据
    picturType: null, //1:头像 2:背景墙
    boxWidth: "", //页面宽度

    viewStatus: "default",
});

const mutations = {
    setState(state, obj) {
        state[obj.type] = obj.data;
    },
    toUserInfo(state, payload) {
        //Online没登录过的话，payload传过来的是undefined
        if (!payload) {
            payload = {
                islogin: false,
            };
        } else {
            payload.lang = "zh";
            if (payload.avatar_url) {
                payload.avatar = payload.avatar_url;
                delete payload.avatar_url;
            }
        }
        state.userInfo = payload;
    },
    setUserInfo(state, payload) {
        for (let key in payload) {
            state.userInfo[key] = payload[key];
        }
    },
    setIntervieweeUserInfo(state, payload) {
        for (let key in payload) {
            state.intervieweeUserInfo[key] = payload[key];
        }
    },
    updateFollowData(state, type) {
        // 更新ta关注的
        if (type) {
            state.followData[0].num++;
        } else {
            state.followData[0].num--;
        }
    },
    updateFansData(state, type) {
        // 更新关注ta的
        if (type) {
            state.followData[1].num++;
        } else {
            state.followData[1].num--;
        }
    },
    updateFollowFans(state, obj) {
        let arr = state.followData[0].data;
        for (let i = 0; i < arr.length; i++) {
            if (arr[i].user_id == obj.id) {
                if (obj.follow) {
                    arr[i].fans_num++;
                } else {
                    arr[i].fans_num--;
                }
            }
        }
    },
    updateFansFans(state, obj) {
        let arr = state.followData[1].data;
        for (let i = 0; i < arr.length; i++) {
            if (arr[i].user_id == obj.id) {
                if (obj.follow) {
                    arr[i].fans_num++;
                } else {
                    arr[i].fans_num--;
                }
            }
        }
    },
    updateHotData(state, obj) {
        switch (obj.key) {
            case "pv":
                break;
            case "like":
                state.hotData[1].num += obj.value;
                break;
            case "used":
                break;
            case "collect":
                state.hotData[3].num += obj.value;
                break;
        }
    },

    clickUserWordId(state, id) {
        state.clickUserWordIds.push(id);
    },

    disClickUserWordId(state, payload) {
        state.clickUserWordIds.splice(payload.start, payload.num);
    },

    like(state, payload) {
        let { id, from } = payload;
        let works;
        if (from == "COLLECT" || state.menuIndex == 1) {
            works = state.collectWorks;
        } else {
            works = state.storeWorks;
        }
        state.likeIds.push(id);
        works.some((item) => {
            if (item.id == id) {
                item.like += 1;
                if (item.user_id == state.viewerID) {
                    this.commit("userPage/updateHotData", {
                        key: "like",
                        value: 1,
                    });
                }
                return true;
            }
        });
    },
    dislike(state, payload) {
        let { id, from } = payload;
        let works;
        if (from == "COLLECT" || state.menuIndex == 1) {
            works = state.collectWorks;
        } else {
            works = state.storeWorks;
        }
        state.likeIds.splice(state.likeIds.indexOf(id), 1);
        works.some((item) => {
            if (item.id == id) {
                item.like -= 1;
                if (item.user_id == state.viewerID) {
                    this.commit("userPage/updateHotData", {
                        key: "like",
                        value: -1,
                    });
                }
                return true;
            }
        });
    },
    collect(state, payload) {
        let { id, from } = payload;
        let works;
        if (from == "COLLECT" || state.menuIndex == 1) {
            works = state.collectWorks;
        } else {
            works = state.storeWorks;
        }
        state.collectIds.push(id);
        works.some((item) => {
            if (item.id == id) {
                item.collect += 1;
                if (item.user_id == state.viewerID) {
                    this.commit("userPage/updateHotData", {
                        key: "collect",
                        value: 1,
                    });
                }
                return true;
            }
        });
    },
    disCollect(state, payload) {
        let { id, from } = payload;
        let works;
        if (from == "COLLECT" || state.menuIndex == 1) {
            works = state.collectWorks;
        } else {
            works = state.storeWorks;
        }
        state.collectIds.splice(state.collectIds.indexOf(id), 1);
        works.some((item) => {
            if (item.id == id) {
                item.collect -= 1;
                if (item.user_id == state.viewerID) {
                    this.commit("userPage/updateHotData", {
                        key: "collect",
                        value: -1,
                    });
                }
                return true;
            }
        });
    },

    // edit modal
    controlBoxShow(state, box) {
        state[box.type] = box.isShow;
    },
    //显示弹出框
    showEdit(state, data) {
        state.iShowEdit = data;
    },
    changePictureType(state, data) {
        state.picturType = data;
    },
    getPitcture(state, data) {
        state.picturefile = data;
    },
    changewidth(state, data) {
        state.boxWidth = data;
    },
};

const actions = {
    getIntervieweeUserInfo({ state, commit }) {
        // 获取被访问者基本信息
        return $edApi.getIntervieweeInfo({ id: state.viewerID }).then((e) => {
            let userInfo = e;
            let ava = "";
            if (userInfo.avatar) ava = "data:image/png;base64," + userInfo.avatar;
            else if (userInfo.avatar_url) ava = userInfo.avatar_url;
            userInfo.avatar = ava ? ava + `?t=${Math.random()}` : "";
            userInfo.user_id = state.viewerID;

            commit("setState", {
                type: "intervieweeUserInfo",
                data: userInfo,
            });
        });
    },
    getUserInfo({ rootGetters, commit }) {
        // 获取访客基本信息
        let list = [];
        list.push(
            $edApi.getUserInfo(rootGetters.apiParam).then((res) => {
                let userInfo = res.data;
                let ava = "";
                if (userInfo.avatar) ava = "data:image/png;base64," + userInfo.avatar;
                else if (userInfo.avatar_url) ava = userInfo.avatar_url;
                commit("setUserInfo", {
                    avatar: ava + `?t=${Math.random()}`,
                    email: userInfo.email,
                    mobile: userInfo.mobile,
                    nick_name: userInfo.nick_name,
                });
                console.log("%c getUserInfo Success", "color:green");
            })
        );

        list.push(
            $edApi
                .getSubscription(rootGetters.apiParam)
                .then((expObj) => {
                    console.log("vipstatus", expObj);
                    let vipStatus = 0;
                    if (expObj) {
                        let { now, online_exp: onlineExp } = expObj,
                            curStamp = new Date(now).getTime(),
                            expStamp = new Date(onlineExp).getTime();

                        if (expStamp > curStamp) {
                            vipStatus = 1;
                        }
                    }
                    commit("setUserInfo", {
                        isVip: vipStatus,
                        updateDone: 1,
                    });
                })
                .catch((err) => {
                    console.log(err);
                    commit("setUserInfo", {
                        isVip: 0,
                        updateDone: 1,
                    });
                })
        );

        return Promise.all(list);
    },
    getIntervieweePublish({ state, commit }) {
        // 获取被访问者发布的模板
        let p = {
            id: state.viewerID,
            offset: 0,
            count: state.pageCount,
            order: "TIME",
            sort: "ASC",
            lang: "zh",
        };
        return $edApi.getIntervieweeWorks(p).then((e) => {
            commit("setState", {
                type: "storeWorks",
                data: e.data,
            });
            commit("setState", {
                type: "worksTotal",
                data: e.msg || 0,
            });
        });
    },
    getIntervieweeCollect({ state, commit }) {
        // 获取被访问者收藏的模板
        let p = {
            id: state.viewerID,
            offset: 0,
            count: state.pageCount,
            order: "TIME",
            sort: "ASC",
            lang: "zh",
        };
        return $edApi.getIntervieweeCollectWorks(p).then((e) => {
            commit("setState", {
                type: "collectWorks",
                data: e.data,
            });
            commit("setState", {
                type: "collectTotal",
                data: e.msg || 0,
            });
        });
    },
    getIntervieweeHotData({ state, commit }) {
        // 获取被访问者热度
        let p = {
            id: state.viewerID,
            offset: 0,
            count: 500,
            order: "TIME",
            sort: "ASC",
            lang: "zh",
        };
        return $edApi.getIntervieweeWorks(p).then((e) => {
            let d = e.data;
            let pv = 0,
                like = 0,
                used = 0,
                collect = 0;
            for (let i = 0; i < d.length; i++) {
                pv += d[i].pv;
                like += d[i].like;
                used += d[i].used;
                collect += d[i].collect;
            }
            let hotData = [
                {
                    id: 0,
                    name: "hotData-0",
                    num: pv,
                    label: "pv",
                },
                {
                    id: 1,
                    name: "hotData-1",
                    num: like,
                    label: "like",
                },
                {
                    id: 2,
                    name: "hotData-2",
                    num: used,
                    label: "used",
                },
                {
                    id: 3,
                    name: "hotData-3",
                    num: collect,
                    label: "collect",
                },
            ];
            commit("setState", {
                type: "hotData",
                data: hotData,
            });
        });
    },
    getRelationships({ state, commit }) {
        // 获取被访问者关注信息
        return $edApi.getRelationships({ id: state.viewerID }).then((e) => {
            let arr = [];
            arr.push({
                id: 0,
                num: (e.follow && e.follow.length) || 0,
                label: "followLabel",
                data: e.follow,
            });
            arr.push({
                id: 1,
                num: (e.fans && e.fans.length) || 0,
                label: "fansLabel",
                data: e.fans,
            });
            commit("setState", {
                type: "followData",
                data: arr,
            });
        });
    },

    getViewerFollowIDs({ state, commit, rootGetters }) {
        // 获取访客关注列表，点赞，收藏模板信息
        let list = [];
        let param = rootGetters.apiParam;
        Object.assign(param, { lang: "zh" });
        list.push(
            $edApi.getRelationships(rootGetters.apiParam).then((e) => {
                let arr = [];
                if (e.follow && e.follow.length > 0) {
                    arr = e.follow.map((v) => v.user_id);
                }
                let index = arr.indexOf(state.viewerID);
                commit("setState", {
                    type: "followIds",
                    data: arr,
                });
                commit("setState", {
                    type: "isFollowing",
                    data: index != -1,
                });
            })
        );
        let temp = Object.assign({}, param);
        delete temp.type;
        list.push(
            $edApi.getLikeAndCollectWorks(Object.assign({ type: "like" }, temp)).then((e) => {
                commit("setState", {
                    type: "likeIds",
                    data: e.map((t) => {
                        return t.id;
                    }),
                });
                commit("setState", {
                    type: "likeWorks",
                    data: e,
                });
            })
        );
        list.push(
            $edApi.getLikeAndCollectWorks(Object.assign({ type: "collect" }, temp)).then((e) => {
                commit("setState", {
                    type: "collectIds",
                    data: e.map((t) => {
                        return t.id;
                    }),
                });
            })
        );
        return Promise.all(list).then((e) => {
            commit("setState", {
                type: "getDataDone",
                data: true,
            });
        });
    },

    // 交互
    doFollow({ state, commit, dispatch, rootGetters }, payload) {
        // 关注被访问者
        let param = rootGetters.apiParam;
        let p = {
            id: param.id,
            token: param.token,
            follow: payload.follow,
            focus_id: state.viewerID,
        };
        return $edApi.follow(p).then((e) => {
            commit("setState", {
                type: "isFollowing",
                data: payload.follow,
            });
            dispatch("getRelationships");
        });
    },
    followOthers({ state, commit, dispatch, rootGetters }, payload) {
        // 关注其他人
        let param = rootGetters.apiParam;
        let p = {
            id: param.id,
            token: param.token,
            follow: payload.follow,
            focus_id: payload.id,
        };
        return $edApi.follow(p).then((e) => {
            let arr = JSON.parse(JSON.stringify(state.followIds));
            let index = arr.indexOf(payload.id);
            commit("setState", {
                type: "followIds",
                data: [],
            });
            if (index != -1) {
                arr.splice(index, 1);
            } else {
                arr.push(payload.id);
            }
            commit("setState", {
                type: "followIds",
                data: arr,
            });

            // 访客==被访者
            if (state.userInfo.user_id == state.viewerID) {
                dispatch("getRelationships");
            }

            // 更新被访问者关注列表中的粉丝信息
            if (payload.type == "follow") {
                commit("updateFollowFans", {
                    id: payload.id,
                    follow: payload.follow,
                });
            } else if (payload.type == "fans") {
                commit("updateFansFans", {
                    id: payload.id,
                    follow: payload.follow,
                });
            }
        });
    },
    getIntervieweePublishByPage({ state, commit }, page) {
        // 获取指定页码被访问者发布的模板
        let offsetPage = Number(page) - 1 < 0 ? 0 : Number(page) - 1;
        let p = {
            id: state.viewerID,
            offset: offsetPage * 50,
            count: state.pageCount,
            order: "TIME",
            sort: "ASC",
            lang: "zh",
        };
        return $edApi.getIntervieweeWorks(p).then((e) => {
            commit("setState", {
                type: "storeWorks",
                data: e.data,
            });
            commit("setState", {
                type: "worksCurrent",
                data: page,
            });
        });
    },
    getIntervieweeCollectByPage({ state, commit }, page) {
        // 获取指定页码被访问者收藏的模板
        let offsetPage = Number(page) - 1 < 0 ? 0 : Number(page) - 1;
        let p = {
            id: state.viewerID,
            offset: offsetPage * 50,
            count: state.pageCount,
            order: "TIME",
            sort: "ASC",
            lang: "zh",
        };
        return $edApi.getIntervieweeCollectWorks(p).then((e) => {
            commit("setState", {
                type: "collectWorks",
                data: e.data,
            });
            commit("setState", {
                type: "collectCurrent",
                data: page,
            });
            commit("setState", {
                type: "collectTotal",
                data: e.msg || 0,
            });
        });
    },
    getIntervieweeLikeWorks({ state, commit, rootGetters }) {
        let param = rootGetters.apiParam;
        Object.assign(param, { lang: "zh" });
        let temp = Object.assign({}, param);
        delete temp.type;
        return new Promise((rs, rj) => {
            $edApi.getLikeAndCollectWorks(Object.assign({ type: "like" }, temp)).then((e) => {
                commit("setState", {
                    type: "likeIds",
                    data: e.map((t) => {
                        return t.id;
                    }),
                });
                commit("setState", {
                    type: "likeWorks",
                    data: e,
                });
                rs(null);
            });
        });
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
